<template>
  <div>
    <div class="code-wrapper" :style="wrapperStyle">
      <code><slot /></code>
    </div>

    <div class="text-right mt-2">
      <button v-if="showExpand"
              type="button"
              @click.prevent="expand = !expand"
              class="btn btn-sm btn-link">{{ expand ? 'Shrink' : 'Expand' }}</button>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      showExpand: {
        type: Boolean,
        default: true
      }
    },
    name: "CodePreview",
    data: () => ({
      expand: false
    }),
    computed: {
      wrapperStyle() {
        if (this.expand)
          return {};

        return {
          maxHeight: '200px'
        };
      }
    }
  }
</script>

<style lang="scss" scoped>
  .code-wrapper {
    padding: 15px;
    border-radius: 5px;
    background-color: rgba(black,0.05);
    border: 1px solid rgba(black,0.1);
    overflow: auto;
    position: relative;

    code {
      white-space: pre;
    }
  }
</style>